module.exports = __webpack_public_path__ + "static/media/Frame.87e024ae.svg";